import { Component } from "@angular/core";
import {
  IonicPage,
  NavController,
  NavParams,
  LoadingController
} from "ionic-angular";
import { Http } from "@angular/http";
import { ViewController } from "ionic-angular";
import config from "../../config/config";

/**
 * Generated class for the FormunicoPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: "page-formunico",
  templateUrl: "formunico.html"
})
export class FormunicoPage {
  recebido = null;
  tes = null;
  form = {
    nome: "",
    email: "",
    mensagem: "",
    categoriatitulo: "",
    cargo: "",
    curso: "",
    nomeEmpresa: "",
    formacao: "",
    finalizado: "", // id do ano
    arquivo: "",
    facebook: "",
    linkedin: ""
  };
  loading = null;
  quem = null;
  foto = "";
  ano = null;

  alterar = 2;
  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public _http: Http,
    public viewCtrl: ViewController
  ) {}

  ionViewDidLoad() {
    this.quem = localStorage.getItem("id");
    this.recebido = this.navParams.get("item");
    this.tes = this.recebido.formulario;
    console.log(this.recebido);
    this.form.nome = this.recebido.formulario.nome_remetente;
    this.form.email = this.recebido.formulario.email_remetente;
    this.form.curso = this.recebido.formulario.curso;
    this.form.nomeEmpresa = this.recebido.formulario.nomeEmpresa;
    this.form.formacao = this.recebido.formulario.graduacao;
    this.form.cargo = this.recebido.formulario.cargo;
    this.form.categoriatitulo = this.recebido.formulario.categoriatitulo;
    this.form.mensagem = this.recebido.formulario.mensagem_remetente;
    this.form.finalizado = this.recebido.formulario.ano;
    this.form.arquivo = this.recebido.formulario.arquivo_remetente;
    this.form.facebook = this.recebido.formulario.facebook;
    this.form.linkedin = this.recebido.formulario.linkedin;

    this.checkFoto();
    this.pegarCategorias();
    // console.log("ionview /n");
    // console.log(this.recebido.formulario);
  }

  pegarCategorias() {
    this._http
      .get(config.urlSite + "Categoria/Pesquisar", {})
      .map(res => res.json())
      .toPromise()
      .then(res => {
        this.ano = res;
        // console.log("log do ano");
        // console.log(this.ano);
      })
      .catch(error => {
        console.log(error);
      });
  }

  atualizarCategoriatitulo(id) {
    console.log(id);

    let anolocal = null;
    for (let p = 0; p < this.ano.length; p++) {
      // const elemento = this.ano[p];
      if (this.ano[p].id == id) {
        console.log("destro do for");

        console.log(this.ano[p].title);
        anolocal = this.ano[p].title;
      }
    }
    return anolocal;
    // this.ano.forEach(anolocal => {

    // });
  }

  carregando() {
    this.loading = this.loadingCtrl.create({
      content: "aguarde."
    });
    this.loading.present();
  }
  closeModal() {
    this.viewCtrl.dismiss();
  }
  flagAlterar() {
    this.alterar = 1;
  }
  alterarform(form) {
    form.id = this.recebido.formulario_id;
    form.finalizado = Number(form.finalizado);
    form.categoriatitulo = this.atualizarCategoriatitulo(form.finalizado);

    this.carregando();
    this._http
      .post(config.urlAPI + "formulario/alterar", form, {})
      .map(res => res.json())
      .toPromise()
      .then(res => {
        this.form.nome = res.nome_remetente;
        this.form.email = res.email_remetente;
        this.form.mensagem = res.mensagem_remetente;
        //this.form.finalizado = res.ano;
        this.alterar = 2;
        console.log("log da resposta");
        console.log(res);
        this.loading.dismiss();
      })
      .catch(error => {
        console.log(error);
      });
    // console.log(form);
  }
  recusar() {
    this.carregando();
    let env = {
      id: this.recebido.id,
      usuario: this.quem
    };
    this._http
      .post(config.urlAPI + "formulario/recusar", env, {})
      .map(res => res.json())
      .toPromise()
      .then(res => {
        this.form.nome = res.nome_remetente;
        this.form.email = res.email_remetente;
        this.form.mensagem = res.mensagem_remetente;
        this.alterar = 2;
        this.closeModal();

        this.loading.dismiss();
      })
      .catch(error => {
        console.log(error);
      });
  }
  checkFoto() {
    if (!this.form.arquivo) {
      // TODO: trocar por imagem escrito "sem foto"
      this.foto = "thumb/RZ6gvd0lz0uhP5pvB5upgVz7wYyjhN3oWwGP71Wp.png";
    } else {
      this.foto = this.form.arquivo;
    }
  }
  aceitar() {
    this.carregando();
    let env = {
      id: this.recebido.id,
      usuario: this.quem
    };
    this._http
      .post(config.urlAPI + "formulario/aceitar", env, {})
      .map(res => res.json())
      .toPromise()
      .then(res => {
        this.alterar = 2;
        this.publicar(this.form);
        // console.log(res);
        this.loading.dismiss();
        this.closeModal();
      })
      .catch(error => {
        console.log(error);
      });
  }
  publicar(form) {
    form.arquivo = this.form.arquivo;
    console.log(this.form);

    this._http
      .post(config.urlSite + "content/cadastrar", form, {})
      .map(res => res.json())
      .toPromise()
      .then(res => {
        console.log(res);
        this.closeModal();
      })
      .catch(error => {
        console.log(error);
      });
  }
}



// WEBPACK FOOTER //
// ./src/pages/formunico/formunico.ts